import { Link, useNavigate } from "react-router-dom";

const FrequentlyQuestions: React.FC<any> = () => {

  return (
    <section className="px-8 md:px-16 xl:px-40 2xl:px-72 mt-10">

      <div className="flex flex-col gap-y-8 flex-1 grow" style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          <p className="[font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-transparent text-4xl tracking-[0.80px] leading-[normal]">
            <span className="text-neutral-800 text-[black]">Duvidas </span>
            <span className="text-[#a27f59]">Frequentes</span>
            <span className="text-neutral-800 text-[black]">(FAQ) </span>
          </p>
        </div>
      </div><br /><br />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap", // Permite que os itens desçam no mobile
          gap: "20px", // Espaçamento entre colunas no desktop
        }}
      >
        <div style={{ flex: "1 1 100%", maxWidth: "calc(50% - 20px)", minWidth: "300px" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "25px",
                  height: "32px",
                  background: "#a27f59",
                  color: "white",
                  alignItems: "center",
                }}
              >
                1.
              </div>
              &nbsp;
              <b>Quais são os benefícios de se tornar um membro?</b>
            </div>
            <div style={{ paddingLeft: "34px", color: "#a4acb8" }}>
              Os membros têm acesso a dicas exclusivas, eventos, classificados, Radar Solidário, descontos com empresas parceiras, networking empresarial e oportunidades de viagens incríveis.
            </div>
          </div>
          <br />
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "25px",
                  height: "32px",
                  background: "#a27f59",
                  color: "white",
                  alignItems: "center",
                }}
              >
                2.
              </div>
              &nbsp;
              <b>Existe mais de um tipo de plano disponível?</b>
            </div>
            <div style={{ paddingLeft: "34px", color: "#a4acb8" }}>
              Sim, oferecemos planos variados para atender as diferentes necessidades, com benefícios personalizados em cada opção.
            </div>
          </div>
          <br />
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "25px",
                  height: "32px",
                  background: "#a27f59",
                  color: "white",
                  alignItems: "center",
                }}
              >
                3.
              </div>
              &nbsp;
              <b>Os descontos são aplicáveis em quais empresas?</b>
            </div>
            <div style={{ paddingLeft: "34px", color: "#a4acb8" }}>
              Os descontos são válidos em uma ampla rede de empresas parceiras, com foco em produtos e serviços de interesse para mulheres empresárias.
            </div>
          </div>
        </div>

        <div style={{ flex: "1 1 100%", maxWidth: "calc(50% - 20px)", minWidth: "300px" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "25px",
                  height: "32px",
                  background: "#a27f59",
                  color: "white",
                  alignItems: "center",
                }}
              >
                4.
              </div>
              &nbsp;
              <b>Como funciona o Radar Solidário?</b>
            </div>
            <div style={{ paddingLeft: "34px", color: "#a4acb8" }}>
              É uma plataforma que conecta membros a iniciativas sociais, promovendo ações solidárias e apoio a causas relevantes.
            </div>
          </div>
          <br />
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "25px",
                  height: "32px",
                  background: "#a27f59",
                  color: "white",
                  alignItems: "center",
                }}
              >
                5.
              </div>
              &nbsp;
              <b>O que é o Business Networking?</b>
            </div>
            <div style={{ paddingLeft: "34px", color: "#a4acb8" }}>
              Uma rede exclusiva para criar conexões valiosas, trocar experiências e impulsionar oportunidades de negócios entre mulheres empreendedoras.
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default FrequentlyQuestions;
